import {command, queryAll, queryOne} from "../../utils/api";

const GET_REGULATORY_BODY_REPORTING_CATEGORIES_URL = `${process.env.PUBLIC_URL}/api/v1/r/regulatoryBodyReportingCategories`;
export const GET_REGULATORY_BODY_REPORTING_CATEGORIES = 'GET_REGULATORY_BODY_REPORTING_CATEGORIES';
export const GET_REGULATORY_BODY_REPORTING_CATEGORIES_COMPLETED = 'GET_REGULATORY_BODY_REPORTING_CATEGORIES_COMPLETED';
export const GET_REGULATORY_BODY_REPORTING_CATEGORIES_FAILED = 'GET_REGULATORY_BODY_REPORTING_CATEGORIES_FAILED';
export function getRegulatoryBodyReportingCategories(where) {
  const queryFilter = {
    where,
    order: "name ASC"
  };
  return queryAll(GET_REGULATORY_BODY_REPORTING_CATEGORIES_URL, queryFilter, GET_REGULATORY_BODY_REPORTING_CATEGORIES, GET_REGULATORY_BODY_REPORTING_CATEGORIES_COMPLETED, GET_REGULATORY_BODY_REPORTING_CATEGORIES_FAILED);
}

export const GET_REGULATORY_BODY_REPORTING_CATEGORY = 'GET_REGULATORY_BODY_REPORTING_CATEGORY';
export const GET_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED = 'GET_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED';
export const GET_REGULATORY_BODY_REPORTING_CATEGORY_FAILED = 'GET_REGULATORY_BODY_REPORTING_CATEGORY_FAILED';
export function getRegulatoryBodyReportingCategory({regulatoryBodyReportingCategoryId}) {
  return queryOne(GET_REGULATORY_BODY_REPORTING_CATEGORIES_URL, {where: {regulatoryBodyReportingCategoryId}}, GET_REGULATORY_BODY_REPORTING_CATEGORY, GET_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED, GET_REGULATORY_BODY_REPORTING_CATEGORY_FAILED);
}

const REGULATORY_BODY_REPORTING_CATEGORY_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/regulatoryBodyReportingCategory`;
export const ADD_REGULATORY_BODY_REPORTING_CATEGORY = 'ADD_REGULATORY_BODY_REPORTING_CATEGORY';
export const ADD_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED = 'ADD_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED';
export const ADD_REGULATORY_BODY_REPORTING_CATEGORY_FAILED = 'ADD_REGULATORY_BODY_REPORTING_CATEGORY_FAILED';
export const addRegulatoryBodyReportingCategory = command(REGULATORY_BODY_REPORTING_CATEGORY_ACTION_URL + '/addRegulatoryBodyReportingCategory', ADD_REGULATORY_BODY_REPORTING_CATEGORY, ADD_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED, ADD_REGULATORY_BODY_REPORTING_CATEGORY_FAILED);

export const UPDATE_REGULATORY_BODY_REPORTING_CATEGORY = 'UPDATE_REGULATORY_BODY_REPORTING_CATEGORY';
export const UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED = 'UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED';
export const UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED = 'UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED';
export const updateRegulatoryBodyReportingCategory = command(REGULATORY_BODY_REPORTING_CATEGORY_ACTION_URL + '/updateRegulatoryBodyReportingCategory', UPDATE_REGULATORY_BODY_REPORTING_CATEGORY, UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED, UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED);

export const DELETE_REGULATORY_BODY_REPORTING_CATEGORY = 'DELETE_REGULATORY_BODY_REPORTING_CATEGORY';
export const DELETE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED = 'DELETE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED';
export const DELETE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED = 'DELETE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED';
export const deleteRegulatoryBodyReportingCategory = command(
  REGULATORY_BODY_REPORTING_CATEGORY_ACTION_URL + '/deleteRegulatoryBodyReportingCategory',
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY,
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED,
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED
);

export const SHOW_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL = 'SHOW_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL';
export function showDeleteRegulatoryBodyReportingCategoryModal(regulatoryBodyReportingCategory) {
  return {type: SHOW_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL, payload: regulatoryBodyReportingCategory};
}

export const HIDE_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL = 'HIDE_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL';
export function hideDeleteRegulatoryBodyReportingCategoryModal() {
  return {type: HIDE_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL};
}



// WEBPACK FOOTER //
// ./src/RegulatoryBody/ReportingCategory/actions.js